export enum BladeburnerActionType {
  General = "General",
  Contract = "Contracts",
  Operation = "Operations",
  BlackOp = "Black Operations",
}

export enum BladeburnerGeneralActionName {
  Training = "Training",
  FieldAnalysis = "Field Analysis",
  Recruitment = "Recruitment",
  Diplomacy = "Diplomacy",
  HyperbolicRegen = "Hyperbolic Regeneration Chamber",
  InciteViolence = "Incite Violence",
}

export enum SpecialBladeburnerActionTypeForSleeve {
  InfiltrateSynthoids = "Infiltrate Synthoids",
  SupportMainSleeve = "Support main sleeve",
  TakeOnContracts = "Take on contracts",
}

export enum BladeburnerContractName {
  Tracking = "Tracking",
  BountyHunter = "Bounty Hunter",
  Retirement = "Retirement",
}

export enum BladeburnerOperationName {
  Investigation = "Investigation",
  Undercover = "Undercover Operation",
  Sting = "Sting Operation",
  Raid = "Raid",
  StealthRetirement = "Stealth Retirement Operation",
  Assassination = "Assassination",
}

export enum BladeburnerBlackOpName {
  OperationTyphoon = "Operation Typhoon",
  OperationZero = "Operation Zero",
  OperationX = "Operation X",
  OperationTitan = "Operation Titan",
  OperationAres = "Operation Ares",
  OperationArchangel = "Operation Archangel",
  OperationJuggernaut = "Operation Juggernaut",
  OperationRedDragon = "Operation Red Dragon",
  OperationK = "Operation K",
  OperationDeckard = "Operation Deckard",
  OperationTyrell = "Operation Tyrell",
  OperationWallace = "Operation Wallace",
  OperationShoulderOfOrion = "Operation Shoulder of Orion",
  OperationHyron = "Operation Hyron",
  OperationMorpheus = "Operation Morpheus",
  OperationIonStorm = "Operation Ion Storm",
  OperationAnnihilus = "Operation Annihilus",
  OperationUltron = "Operation Ultron",
  OperationCenturion = "Operation Centurion",
  OperationVindictus = "Operation Vindictus",
  OperationDaedalus = "Operation Daedalus",
}

export enum BladeburnerSkillName {
  BladesIntuition = "Blade's Intuition",
  Cloak = "Cloak",
  ShortCircuit = "Short-Circuit",
  DigitalObserver = "Digital Observer",
  Tracer = "Tracer",
  Overclock = "Overclock",
  Reaper = "Reaper",
  EvasiveSystem = "Evasive System",
  Datamancer = "Datamancer",
  CybersEdge = "Cyber's Edge",
  HandsOfMidas = "Hands of Midas",
  Hyperdrive = "Hyperdrive",
}

export enum BladeburnerMultName {
  SuccessChanceAll = "Total Success Chance",
  SuccessChanceStealth = "Stealth Success Chance",
  SuccessChanceKill = "Retirement Success Chance",
  SuccessChanceContract = "Contract Success Chance",
  SuccessChanceOperation = "Operation Success Chance",
  SuccessChanceEstimate = "Synthoid Data Estimate",
  ActionTime = "Action Time",
  EffStr = "Effective Strength",
  EffDef = "Effective Defense",
  EffDex = "Effective Dexterity",
  EffAgi = "Effective Agility",
  EffCha = "Effective Charisma",
  Stamina = "Stamina",
  Money = "Contract Money",
  ExpGain = "Experience Gain",
}
